import { Skeleton, Typography } from 'antd'

import { createUseStyles } from 'react-jss'
import { Link } from 'react-router-dom'
import { useCurrentUser } from '../../redux/slices/session'
import routes from '../../routes'
import { XL_MEDIA_QUERY } from '../../lib/responsive'

const { Text } = Typography

const useStyles = createUseStyles({
  userName: {
    display: 'block',
    maxWidth: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  skeleton: {
    width: '80px',
    marginRight: '10px',
  },
  userNameLink: {
    display: 'flex',
    justifyContent: 'flex-end',
    flexDirection: 'column',
    textAlign: 'right',
    minWidth: 0,
    maxWidth: '100%',
    overflow: 'hidden',
  },
  userNameLinkContainer: {
    minWidth: 0,
    width: '100%',
    maxWidth: '100%',
    [XL_MEDIA_QUERY]: {
      maxWidth: '80%',
    },
  },
})

export default function ProfileLink() {
  const classes = useStyles()
  const { firstName, lastName, practice } = useCurrentUser()
  const fullName = `${firstName} ${lastName}`

  return (
    <div className={classes.userNameLinkContainer}>
      <Skeleton
        active
        className={classes.skeleton}
        loading={false}
        paragraph={false}
      >
        <Link to={routes.profile()} className={classes.userNameLink}>
          <Text className={classes.userName} title={fullName}>{fullName}</Text>
          {practice?.name && (
            <Text
              type="secondary"
              className={classes.userName}
              title={practice.name}
            >
              {practice.name}
            </Text>
          )}
        </Link>
      </Skeleton>
    </div>
  )
}
